var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2076,
    height: 2923,
    transform: "translate(-696 -1677)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 33.598 33.598 43 22 43C10.402 43 1 33.598 1 22C1 10.402 10.402 1 22 1C33.598 1 43 10.402 43 22Z",
    stroke: "#C5C9DB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2077 14.9563C17.5171 15.6305 16.1237 16.8876 15.2795 18.5H17.7103C17.9697 17.2313 18.4787 16.0267 19.2077 14.9563Z",
    fill: "#258E61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 22.0001C17.3338 21.2193 17.3895 20.4396 17.5001 19.6667H14.7876C14.2931 21.183 14.2931 22.8172 14.7876 24.3334H17.5001C17.3895 23.5605 17.3338 22.7808 17.3333 22.0001Z",
    fill: "#258E61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0918 18.5001C24.4635 15.9696 23.2024 14.4167 22.0001 14.4167C20.7979 14.4167 19.5344 15.9696 18.9084 18.5001H25.0918Z",
    fill: "#258E61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.0001C18.4985 22.7811 18.5558 23.561 18.6715 24.3334H25.3285C25.5572 22.7863 25.5572 21.2139 25.3285 19.6667H18.6715C18.5558 20.4391 18.4985 21.2191 18.5 22.0001Z",
    fill: "#258E61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2795 25.5C16.1237 27.1125 17.5171 28.3695 19.2077 29.0438C18.4787 27.9734 17.9697 26.7688 17.7103 25.5H15.2795Z",
    fill: "#258E61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 22.0001C26.6664 22.7808 26.6106 23.5605 26.5 24.3334H29.2125C29.707 22.8172 29.707 21.183 29.2125 19.6667H26.5C26.6106 20.4396 26.6664 21.2193 26.6668 22.0001Z",
    fill: "#258E61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C19.2311 8 16.5243 8.82109 14.222 10.3594C11.9197 11.8978 10.1253 14.0843 9.06569 16.6424C8.00607 19.2006 7.72882 22.0155 8.26901 24.7313C8.80921 27.447 10.1426 29.9416 12.1005 31.8995C14.0584 33.8574 16.553 35.1908 19.2687 35.731C21.9845 36.2712 24.7994 35.9939 27.3576 34.9343C29.9157 33.8747 32.1022 32.0803 33.6406 29.778C35.1789 27.4757 36 24.7689 36 22C35.9957 18.2883 34.5193 14.7299 31.8947 12.1053C29.2702 9.48071 25.7117 8.00432 22 8ZM22 30.75C20.2694 30.75 18.5777 30.2368 17.1388 29.2754C15.6998 28.3139 14.5783 26.9473 13.9161 25.3485C13.2538 23.7496 13.0805 21.9903 13.4181 20.293C13.7558 18.5956 14.5891 17.0365 15.8128 15.8128C17.0365 14.5891 18.5956 13.7557 20.293 13.4181C21.9903 13.0805 23.7496 13.2538 25.3485 13.9161C26.9473 14.5783 28.3139 15.6998 29.2754 17.1388C30.2368 18.5777 30.75 20.2694 30.75 22C30.7474 24.3198 29.8247 26.5439 28.1843 28.1843C26.5439 29.8247 24.3198 30.7474 22 30.75Z",
    fill: "#258E61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9084 25.5C19.5367 28.0305 20.7979 29.5833 22.0001 29.5833C23.2024 29.5833 24.4659 28.0305 25.0918 25.5H18.9084Z",
    fill: "#258E61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7925 14.9563C25.5215 16.0267 26.0304 17.2313 26.2899 18.5H28.7206C27.8765 16.8876 26.4831 15.6305 24.7925 14.9563Z",
    fill: "#258E61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7925 29.0438C26.4831 28.3695 27.8765 27.1125 28.7206 25.5H26.2899C26.0304 26.7688 25.5215 27.9734 24.7925 29.0438Z",
    fill: "#258E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.628800fc25617a5a7386cd2da6de45d7.svg";
export { ForwardRef as ReactComponent };